import { combineReducers } from 'redux'
import baseInfo from './baseInfo'
import categoryInfo from './category'
import contentType from './contentType'
import timeLine from './timeLine'
import createVideo from './createVideo'
import quickGenerate from './quickGenerate'
const rootReducer = combineReducers({
	baseInfo,
	timeLine,
	categoryInfo,
	contentType,
	createVideo,
	quickGenerate
})
export default rootReducer